export default function PageIntro({ children }) {
  return (
    <section className="bg-[#fff7fb]">
      <div className="mx-auto max-w-7xl px-6 pb-2 pt-12 sm:px-10 lg:px-16 xl:px-6">
        <p className="max-w-3xl text-base leading-relaxed text-black/70 md:text-lg">
          {children}
        </p>
      </div>
    </section>
  );
}
